import xw from 'xwind';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const ReactionContainer = styled.div(xw`w-full flex justify-center`);

export const StyledReactinButton = styled.button(
  xw`
    flex justify-center items-center
    border border-primary rounded-full
    text-primary text-sm px-4
    mr-4 last:mr-0 focus:outline-none
    xs:mr-6 sm[mr-8 text-base px-6]`,
  css`
    height: 42px;

    @media (min-width: 640px) {
      min-width: 109px;
    }
  `,
);

export const Text = styled.span(xw`ml-2 sm:ml-2.5`);

export const LoadedText = styled(Text)(
  xw`animate-pulse h-4 w-7 bg-gray-200 rounded`,
);
